import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/voyage/voyage.constants";
import {
    GetCarbonAccountingSummaryReportDataRequest,
    GetVoyageIdsFromPortRouteRequest,
    VoyageDeclarationResponse
} from "../../models/carbon-accounting/carbon-accounting.models";

@autoinject
export class VoyageService {
    constructor(private requestClient: RequestClientService) {
    }

    public computeEmissions(id: number): Promise<any> {
        return this.requestClient.post(`${Urls.ComputeVoyageEmissions}/${id}`, {  });
    }

    public forceReporting(id: number): Promise<any> {
        return this.requestClient.post(`${Urls.ComputeVoyageEmissions}/${id}`, {  });
    }

    public generateExcelFiles(id: number): Promise<void>
    {
        return this.requestClient.post(`${Urls.GenerateExcelFiles}/${id}`, {  });
    }

    public getVoyageInfo(voyageId: number): Promise<any> {
        return this.requestClient.get(`${Urls.GetVoyageInfo}/${voyageId}`);
    }

    public getCarbonAccountingSummaryReportData (request: GetCarbonAccountingSummaryReportDataRequest): Promise<any> {
        return this.requestClient.get<any>(`${Urls.GetCarbonAccountingSummaryReportData}`, request)
    }
    
    public getCarbonAccountingVoyageSubmissionYears (customerId: number): Promise<any> {
        return this.requestClient.get<any>(`${Urls.GetCarbonAccountingVoyageSubmissionYears}/${customerId}`)
    }
    
    public getVoyageIdsFromPortRoute (request: GetVoyageIdsFromPortRouteRequest): Promise<any> {
        return this.requestClient.get<any>(`${Urls.GetVoyageIdsFromPortRoute}`, request);
    }

    public getVoyageDeclaration (voyageId: number): Promise<VoyageDeclarationResponse> {
        return this.requestClient.get<VoyageDeclarationResponse>(`${Urls.GetVoyageDeclaration}/${voyageId}`);
    }
}